import React from 'react';
import LanguageSelector from './LanguageSelector';
import ProviderSelector from './ProviderSelector';
import HighlightedCode from './HighlightedCode';
import CodeSnippetActions from '@/shared/components/CodeSnippetActions';

const FILE_EXTENSIONS = { python: 'py', go: 'go', typescript: 'js' };

const CodeBlockWithSelector = ({
    codeVariants,
    renderCode,
    codeLanguage,
    languages,
    showProviderSelector = false,
    showLanguageSelector = true,
    showDownloadButton = true,
    defaultLanguage = 'python',
    defaultProvider = 'openai'
}) => {
    const [selectedLanguage, setSelectedLanguage] = React.useState(defaultLanguage);
    const [selectedProvider, setSelectedProvider] = React.useState(defaultProvider);

    const getCurrentCode = () => {
        if (showProviderSelector) {
            return codeVariants[`${selectedLanguage}_${selectedProvider}`] || '';
        }
        return codeVariants[selectedLanguage] || '';
    };

    const code = getCurrentCode();
    const extension = FILE_EXTENSIONS[selectedLanguage] || 'txt';
    const filename = `specific_ai_${selectedProvider}_basic_usage.${extension}`;

    return (
        <div className="docs-code-block">
            <div className="docs-code-toolbar">
                {showProviderSelector && (
                    <ProviderSelector
                        selectedProvider={selectedProvider}
                        onProviderChange={setSelectedProvider}
                    />
                )}
                {showLanguageSelector && (
                    <LanguageSelector
                        selectedLanguage={selectedLanguage}
                        onLanguageChange={setSelectedLanguage}
                        {...(languages ? { languages } : {})}
                    />
                )}
                <CodeSnippetActions
                    code={code}
                    filename={filename}
                    variant="secondary"
                    showDownload={showDownloadButton}
                />
            </div>
            {renderCode ? (
                <div className="docs-code-pre-wrap">
                    <pre className="docs-code-pre">
                        {renderCode(selectedLanguage, selectedProvider)}
                    </pre>
                </div>
            ) : (
                <HighlightedCode
                    code={code}
                    language={(codeLanguage && codeLanguage[selectedLanguage]) || selectedLanguage}
                />
            )}
        </div>
    );
};

export default CodeBlockWithSelector;
